import styles from './TitleFlex.module.scss'
import { useEffect, useRef } from 'react'
import { gsap, Power4 } from 'gsap'

import { ScrollTrigger } from 'gsap/dist/ScrollTrigger'
gsap.registerPlugin(ScrollTrigger)

const tweenVars: gsap.TimelineVars = [
  {
    y: '50',
    duration: 1,
    opacity: 0,
    ease: Power4.easeOut,
  },
  {
    x: '-50',
    duration: 0.5,
    opacity: 0,
    ease: Power4.easeOut,
  },
]
interface Props {
  sectionTitle: {
    title: string
    sub_title: string
  }
}

const Process: React.FC<Props> = ({ sectionTitle }) => {
  const timeline = gsap.timeline()
  const title = useRef<HTMLDivElement>()

  useEffect(() => {
    Array.prototype.forEach.call(title.current.children, (element: HTMLElement, index: number) => {
      timeline.from(element.childNodes, tweenVars[0], 0.2 * (index + 1))
    })

    ScrollTrigger.create({
      animation: timeline,
      trigger: title.current,
      start: 'top-=250 90%',
      toggleActions: 'play none none play',
    })
  }, [])
  return (
    <div className={styles.title_group} ref={title}>
      <div className={styles.title_container}>
        <h2 className={styles.title}>{sectionTitle.title}</h2>
        <h2 className={styles.sub_title}>{sectionTitle.sub_title}</h2>
      </div>
    </div>
  )
}

export default Process
